export interface ICardMachine {
  id: number;
  position: string;
  name: string;
  port: string;
  ip: string;
}

export const defaultCardMachine: ICardMachine = {
  id: 0,
  position: "",
  name: "",
  port: "",
  ip: "",
};
